module.exports = __webpack_public_path__ + "static/img/manual_ja_25.d15f150.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_25.png
// module id = O+qi
// module chunks = 4